import { render, staticRenderFns } from "./ProjectFolderActionsDelete.vue?vue&type=template&id=bd9bd3d8&lang=pug&"
import script from "./ProjectFolderActionsDelete.vue?vue&type=script&lang=js&"
export * from "./ProjectFolderActionsDelete.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFolderActionsDelete.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports